export default "__VITE_ASSET__69392d9a__"